module.exports = __webpack_public_path__ + "static/media/man.f48d1b5c.jpg";